import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import { sharedRoutes } from './sharedRoutes'

Vue.use(VueRouter)

export const createAppRouter = function ({ productRoutes, defaultAuthenticatedRoute }) {
  const router = new VueRouter({
    routes: [
      ...sharedRoutes,
      ...productRoutes,
      {
        path: '*',
        redirect: '/LogIn'
      }
    ]
  })

  router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('auth_token')
    const expires = localStorage.getItem('auth_expires')

    if (token && expires && Date.now() > parseInt(expires)) {
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_expires')
      localStorage.removeItem('user_info')
      store.commit('CLEAR_AUTH')
      console.log('⏰ Token 已過期，自動登出')
    }

    const isAuthenticated = store.getters.isLoggedIn
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

    console.log('🔒 路由守衛檢查:', {
      目標頁面: to.path,
      需要登入: requiresAuth,
      已登入: isAuthenticated
    })

    if (requiresAuth && !isAuthenticated) {
      console.log('❌ 未登入，跳轉到登入頁')
      next({
        path: '/LogIn',
        query: { redirect: to.fullPath }
      })
    } else if (to.path === '/LogIn' && isAuthenticated) {
      console.log('✅ 已登入，跳轉到系統預設頁')
      next({ path: defaultAuthenticatedRoute })
    } else {
      next()
    }
  })

  return router
}
